var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertYellowTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2153 19.9212H20.7853C22.582 19.9212 23.702 17.9729 22.8036 16.4212L14.0186 1.24285C13.1203 -0.308815 10.8803 -0.308815 9.98197 1.24285L1.19697 16.4212C0.298638 17.9729 1.41864 19.9212 3.2153 19.9212ZM12.0003 11.7545C11.3586 11.7545 10.8336 11.2295 10.8336 10.5879V8.25452C10.8336 7.61285 11.3586 7.08785 12.0003 7.08785C12.642 7.08785 13.167 7.61285 13.167 8.25452V10.5879C13.167 11.2295 12.642 11.7545 12.0003 11.7545ZM13.167 16.4212H10.8336V14.0879H13.167V16.4212Z",
    fill: "#F29423"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertYellowTriangle);
export default __webpack_public_path__ + "static/media/icon_alert_yellow_triangle.f8b7d268333e2d711eea0bff2b04ecbd.svg";
export { ForwardRef as ReactComponent };